<template>
  <div>
    <ul class="mobile-fix-option">
      <li
        class="mobile-home mobile-menu"
        :class="{ active: $route.name === 'home' }"
      >
        <router-link :to="{ name: 'home' }">
          <div class="top">
            <svg width="34" height="20" fill="none">
              <use xlink:href="#mobile-home-icon" />
            </svg>
            <!-- <img src="assets/svg/home.svg" class="img-fluid" alt=""> -->
          </div>
          <span>{{ _T('Home') }}</span>
        </router-link>
      </li>
      <li
        class="mobile-location mobile-menu"
        :class="{ active: $route.name === 'profile.ongoing-orders' }"
      >
        <a href="javascript:void(0)" @click="showOrders()">
          <div class="top">
            <svg width="34" height="20" fill="none">
              <use xlink:href="#mobile-order-icon" />
            </svg>
          </div>
          <span>{{ _T('Order') }}</span>
        </a>
      </li>
      <!-- <li
        id="open-cart"
        class="mobile-cart mobile-menu"
        @click="navigateToCart()"
      >
        <div class="top">
          <svg width="34" height="20" fill="none">
            <use xlink:href="#mobile-cart-icon" />
          </svg>
        </div>
        <span>{{ _T('Cart') }}</span>
      </li> -->
      <li
        id="click-search"
        class="mobile-search mobile-menu"
        @click="$bvModal.show('open-search')"
      >
        <!-- <div class="top" v-b-modal.mobile-search> -->
        <div class="top">
          <svg width="34" height="20" fill="none">
            <use xlink:href="#mobile-search-icon" />
          </svg>
        </div>
        <span>{{ _T('Search') }}</span>
      </li>
      <li
        class="mobile-account mobile-menu"
        v-if="isFloorTableAvailable.table_id"
        :class="{ active: $route.name === 'login' }"
      >
        <a
          href="javascript:void(0)"
          @click="notifyToStore({ message: 'Calling waiter' })"
        >
          <div class="top">
            <svg width="34" height="20" fill="none">
              <use xlink:href="#mobile-account-icon" />
            </svg>
          </div>
          <span>{{ _T('Waiter') }}</span>
        </a>
      </li>
      <li
        class="mobile-account mobile-menu"
        v-else-if="!this.is_customer_logged_in"
        :class="{ active: $route.name === 'login' }"
      >
        <a href="javascript:void(0)" @click="$bvModal.show('login')">
          <div class="top">
            <svg width="34" height="20" fill="none">
              <use xlink:href="#mobile-account-icon" />
            </svg>
          </div>
          <span>{{ _T('Login') }}</span>
        </a>
      </li>

      <li
        v-else
        class="mobile-account mobile-menu"
        :class="{ active: $route.name === 'profile.personal-info' }"
      >
        <router-link :to="{ name: 'profile.personal-info' }">
          <div class="top">
            <svg width="34" height="20" fill="none">
              <use xlink:href="#mobile-account-icon" />
            </svg>
          </div>
          <span>{{ _T('Profile') }}</span>
        </router-link>
      </li>
    </ul>
    <mobile-search-modal />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MobileSearchModal from '@/components/Modals/MobileSearchModal'
export default {
  name: 'MobileMenu',
  components: {
    MobileSearchModal,
  },
  computed: {
    ...mapGetters([
      '_T',
      'is_customer_logged_in',
      'brandStoreRoute',
      'brandStoreParams',
      'cart_items_count',
      'isFloorTableAvailable',
    ]),
  },
  methods: {
    notifyToStore(data) {
      this.$store.dispatch('notifyStoreAboutTable', data)
    },
    navigateToCart() {
      if (!this.cart_items_count) {
        this.$store.dispatch('showNotification', {
          text: this._T('Please add some items in cart'),
          status: 'error',
        })
        return
      }

      this.$router.push({
        name: this.brandStoreRoute('cart'),
        params: {
          ...this.brandStoreParams,
        },
      })
    },
    opensearch() {},
    showOrders() {
      const webUserToken = localStorage.getItem('webuser_token')
      if (webUserToken && this.is_customer_logged_in) {
        this.$router.push({
          name: 'profile.ongoing-orders',
        })
      } else {
        this.$bvModal.show('login')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mobile-fix-option {
  display: none;
}
@media (max-width: 767px) {
  .mobile-fix-option {
    position: fixed;
    bottom: 0;
    left: 0;
    height: $px60;
    background-color: $color-primary;
    width: 100vw;
    z-index: 3;
    padding: $px10;
    box-shadow: 0 $px2 $px5 0 $grey-3;
    display: flex;
    justify-content: space-around;
    .top {
      width: $px22;
      height: $px22;
      margin: 0;
      .mobile-option-icons {
        width: $px22;
        height: $px22;
      }
    }
    .mobile-menu {
      display: block;
      text-align: center;
      opacity: 0.7;
      .svg-size {
        width: $px20;
        height: $px20;
      }
      span {
        display: block;
        color: $white;
        font-size: $px12;
        line-height: $px15;
        letter-spacing: 0.02em;
        margin-top: $px5;
        text-transform: capitalize;
      }
      &.active {
        opacity: 1;
        span {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
